var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { cookie } from '../../../base/base';
import { bottomSlidesFn } from '../utils/api';
import BottomSlides from '../bottomSlides';
/**
 * 下推页面wiki
 * http://know.ifengidc.com/pages/viewpage.action?pageId=15509938  old
 * http://api.ifengcloud.ifeng.com/project/524/interface/api/19989 new
 *
 */
class UpgradeBottomSlides extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            bottomSlideData: [],
        };
        // 获取链接地址加密id
        this.getUrlSecretId = (url) => {
            if (url) {
                return url.split('?')[0].split('/').pop();
            }
            else {
                return url;
            }
        };
    }
    componentDidMount() {
        this.bottomSlideFn();
    }
    bottomSlideFn() {
        return __awaiter(this, void 0, void 0, function* () {
            const { content } = this.props;
            const { apiConfig } = content;
            let slidesData = yield this.getSlidesData(apiConfig);
            // const slidesData = this.taobaoData();
            let formalData = this.formalDataFn(slidesData);
            if (slidesData && slidesData.length > 0) {
                this.setState({
                    bottomSlideData: formalData,
                });
            }
        });
    }
    taobaoData() {
        return [
            {
                id: 'treasure_001',
                title: '疯抢双11立即GO',
                thumbnailpic: 'https://x0.ifengimg.com/cmpp/2019/1111/d531bf85ce0e4f9size181_w375_h225.png',
                newstype: 'doc',
                channel: 'treasure',
                share: 'https://click.tanx.com/tfn?e=chOYpK52K2wnxTAbA1%2bSdTYckvK5Pl7vaaLGI3nhbD%2blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%2bWElSh0WKJgzS%2bNWQ70%3d&u=https%3a%2f%2f1111.tmall.com%2fmedia%3fbc_fl_src%3dtanx_df_109737200226_0_20529_130305_41002_3727_4639_3%26resource_id%3d20529&k=140&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
                dlUrl: 'tbopen://m.taobao.com/tbopen/index.html?action=ali.open.nav&bootImage=0&module=h5&source=alimama&visa=5d429034ad046701&appkey=24558693&bc_fl_src=tanx_df_109737200226_0_20529_130305_41002_3727_4639_3&backURL=&packageName=com.ifeng.news2&h5Url=https%3A%2F%2Fclick.tanx.com%2Ftfn%3Fe%3D%252fhhiy8hSGe51LD%252baSsCZU0r8UcIDd7jhaaLGI3nhbD%252blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%252bWElSh0WKJgzS%252bNWQ70%253d%26u%3Dhttps%253a%252f%252f1111.tmall.com%252fmedia%253fresource_id%253d20529%26k%3D140%26ext%3Da%253d__IMEI__%2526b%253d__IDFA__%2526c%253d__MAC__%2526d%253d__OAID__',
            },
            {
                id: 'treasure_002',
                title: '疯抢双11立即GO',
                thumbnailpic: 'http://x0.ifengimg.com/cmpp/2019/1111/e8f04d61e9f1bb7size162_w375_h225.png',
                newstype: 'doc',
                channel: 'treasure',
                share: 'https://click.tanx.com/tfn?e=chOYpK52K2wnxTAbA1%2bSdTYckvK5Pl7vaaLGI3nhbD%2blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%2bWElSh0WKJgzS%2bNWQ70%3d&u=https%3a%2f%2f1111.tmall.com%2fmedia%3fbc_fl_src%3dtanx_df_109737200226_0_20529_130305_41002_3727_4639_3%26resource_id%3d20529&k=140&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
                dlUrl: 'tbopen://m.taobao.com/tbopen/index.html?action=ali.open.nav&bootImage=0&module=h5&source=alimama&visa=5d429034ad046701&appkey=24558693&bc_fl_src=tanx_df_109737200226_0_20529_130305_41002_3727_4639_3&backURL=&packageName=com.ifeng.news2&h5Url=https%3A%2F%2Fclick.tanx.com%2Ftfn%3Fe%3D%252fhhiy8hSGe51LD%252baSsCZU0r8UcIDd7jhaaLGI3nhbD%252blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%252bWElSh0WKJgzS%252bNWQ70%253d%26u%3Dhttps%253a%252f%252f1111.tmall.com%252fmedia%253fresource_id%253d20529%26k%3D140%26ext%3Da%253d__IMEI__%2526b%253d__IDFA__%2526c%253d__MAC__%2526d%253d__OAID__',
            },
            {
                id: 'treasure_003',
                title: '疯抢双11立即GO',
                thumbnailpic: 'https://x0.ifengimg.com/cmpp/2019/1111/7efe80247b92c05size169_w374_h226.png',
                newstype: 'doc',
                channel: 'treasure',
                share: 'https://click.tanx.com/tfn?e=chOYpK52K2wnxTAbA1%2bSdTYckvK5Pl7vaaLGI3nhbD%2blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%2bWElSh0WKJgzS%2bNWQ70%3d&u=https%3a%2f%2f1111.tmall.com%2fmedia%3fbc_fl_src%3dtanx_df_109737200226_0_20529_130305_41002_3727_4639_3%26resource_id%3d20529&k=140&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
                dlUrl: 'tbopen://m.taobao.com/tbopen/index.html?action=ali.open.nav&bootImage=0&module=h5&source=alimama&visa=5d429034ad046701&appkey=24558693&bc_fl_src=tanx_df_109737200226_0_20529_130305_41002_3727_4639_3&backURL=&packageName=com.ifeng.news2&h5Url=https%3A%2F%2Fclick.tanx.com%2Ftfn%3Fe%3D%252fhhiy8hSGe51LD%252baSsCZU0r8UcIDd7jhaaLGI3nhbD%252blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%252bWElSh0WKJgzS%252bNWQ70%253d%26u%3Dhttps%253a%252f%252f1111.tmall.com%252fmedia%253fresource_id%253d20529%26k%3D140%26ext%3Da%253d__IMEI__%2526b%253d__IDFA__%2526c%253d__MAC__%2526d%253d__OAID__',
            },
            {
                id: 'treasure_004',
                title: '疯抢双11立即GO',
                thumbnailpic: 'https://x0.ifengimg.com/cmpp/2019/1111/9ab945e517e6849size158_w375_h227.png',
                newstype: 'doc',
                channel: 'treasure',
                share: 'https://click.tanx.com/tfn?e=chOYpK52K2wnxTAbA1%2bSdTYckvK5Pl7vaaLGI3nhbD%2blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%2bWElSh0WKJgzS%2bNWQ70%3d&u=https%3a%2f%2f1111.tmall.com%2fmedia%3fbc_fl_src%3dtanx_df_109737200226_0_20529_130305_41002_3727_4639_3%26resource_id%3d20529&k=140&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
                dlUrl: 'tbopen://m.taobao.com/tbopen/index.html?action=ali.open.nav&bootImage=0&module=h5&source=alimama&visa=5d429034ad046701&appkey=24558693&bc_fl_src=tanx_df_109737200226_0_20529_130305_41002_3727_4639_3&backURL=&packageName=com.ifeng.news2&h5Url=https%3A%2F%2Fclick.tanx.com%2Ftfn%3Fe%3D%252fhhiy8hSGe51LD%252baSsCZU0r8UcIDd7jhaaLGI3nhbD%252blaGxvW1qsSukA6gLylKaK5L28So819SE5Gxnf1gfaSILT2sAZVeROoBNXeleV94Gs6uJqbJH4jUAg%252bWElSh0WKJgzS%252bNWQ70%253d%26u%3Dhttps%253a%252f%252f1111.tmall.com%252fmedia%253fresource_id%253d20529%26k%3D140%26ext%3Da%253d__IMEI__%2526b%253d__IDFA__%2526c%253d__MAC__%2526d%253d__OAID__',
            },
        ];
    }
    formalDataFn(data) {
        const { content } = this.props;
        const { insertSlideArr, lastSlideData, slideLength = 4 } = content;
        if (!data || data.length === 0) {
            data = [
                {
                    id: '',
                    title: '',
                    thumbnailpic: '',
                    newstype: 'nodata',
                    style: '',
                    share: '',
                    kind: '',
                    channel: '',
                    dlUrl: '',
                    abTest: '',
                    toId: '',
                },
            ];
        }
        const slideDataArr = data.slice(0, slideLength).map((item, index) => {
            var _a, _b, _c;
            return ({
                id: item.id || index,
                _id: (item.share && this.getUrlSecretId(item.share)) ||
                    (((_a = item === null || item === void 0 ? void 0 : item.link) === null || _a === void 0 ? void 0 : _a.weburl) && this.getUrlSecretId((_b = item === null || item === void 0 ? void 0 : item.link) === null || _b === void 0 ? void 0 : _b.weburl)) ||
                    item.id,
                title: item.title,
                thumbnailpic: item.thumbnailpic ||
                    (item.thumbnail &&
                        item.thumbnail
                            .replace(/_webp/g, '')
                            .replace(/jpg\.webp/g, 'jpg')
                            .replace(/png\.webp/g, 'png')) ||
                    '',
                newstype: item.newstype || item.type || 'doc',
                style: 'titleimg',
                share: item.share || ((_c = item === null || item === void 0 ? void 0 : item.link) === null || _c === void 0 ? void 0 : _c.weburl) || '',
                kind: 'default_downopen',
                channel: item.channel || '',
                dlUrl: item.dlUrl || '',
                abTest: item.abTest || '',
                toId: item.commentsUrl || item.documentId || item.id || index,
            });
        });
        if (insertSlideArr && insertSlideArr.length > 0) {
            slideDataArr.map((item, index) => {
                if (insertSlideArr[index]) {
                    if (insertSlideArr[index].clickCount &&
                        insertSlideArr[index].clickCount.other &&
                        insertSlideArr[index].clickCount.other.to) {
                        insertSlideArr[index].clickCount.other.to = item.id;
                    }
                    return Object.assign(item, insertSlideArr[index]);
                }
                return null;
            });
        }
        if (lastSlideData) {
            slideDataArr.push(lastSlideData);
        }
        return slideDataArr;
    }
    getSlidesData(apiConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            const configInfo = apiConfig;
            const arrList = [];
            const userId = cookie.get('userid') || this.getUserid() || '';
            let config = '';
            configInfo.deviceId = userId;
            configInfo.uid = userId;
            configInfo.city = cookie.get('city') || '';
            const apiUrl = apiConfig.apiUrl || '';
            for (const index in configInfo) {
                if (index !== 'apiUrl') {
                    arrList.push(`${index}=${encodeURIComponent(configInfo[index])}`);
                }
            }
            config = arrList.join('&');
            try {
                const dataCb = yield bottomSlidesFn(config, apiUrl);
                return dataCb;
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    getUserid() {
        const e = ((2147483648 * Math.random()) | 0).toString(36);
        const t = Math.round(1e4 * Math.random());
        const n = new Date().getTime();
        return `${n}_${e}${t}`;
    }
    render() {
        const { bottomSlideData } = this.state;
        const { content, noCloseIcon = false, maxWidth, ad } = this.props;
        const { isLogoPic, sendSucessLog } = content;
        const isVideoShare = content.isVideoShare || false;
        return (bottomSlideData.length > 0 &&
            (isLogoPic ? (React.createElement(BottomSlides, { content: bottomSlideData, isVideoShare: isVideoShare, aidIndex: [bottomSlideData.length], noCloseIcon: noCloseIcon, maxWidth: maxWidth, sendSucessLog: sendSucessLog, ad: ad })) : (React.createElement(BottomSlides, { content: bottomSlideData, isVideoShare: isVideoShare, noCloseIcon: noCloseIcon, maxWidth: maxWidth, sendSucessLog: sendSucessLog, ad: ad }))));
    }
}
export default UpgradeBottomSlides;
